// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"bd5ac2af","239":"44b8b2ea","268":"5c037159","455":"bf7cebf9","457":"50dfc11c","828":"ddcf1bfe","842":"02495090","977":"90c92dd1"}[chunkId] + ".chunk.js";
};